import { GenericArticleCondition } from '../../services/products-category.service';
import { Offer, OfferItem } from '../../models/quote.model';

export enum ConditionType {
    partner = 'ZVGP',
    custom = 'PR00',
}

export interface UserRoleDependantOrderType {
    employee: string;
    customer: string;
}

interface MaterialProduct {
    materialNumber: string;
    amount: number;
}

export interface PriceLiteParams {
    salesOrg: string;
    language: string;
    country: string;
    materials?: MaterialProduct[];
    conditions?: GenericArticleCondition[];
    priceAdvantageEnabled: boolean;
}

interface PricesLite {
    totalGross: number;
    totalAdvantage: number;
    totalPrice: number;
}

export interface Prices extends PricesLite {
    netPrice: number;
    vat: number;
    vatRate: number;
    sum: number;
    voucherValue: number;
}

interface CalculatePriceResponse<T> {
    prices: T;
    isFull: boolean;
}

export interface CalculatePriceLiteResponse extends CalculatePriceResponse<PricesLite> {
    isFull: false;
}

export interface CalculatePriceFullResponse extends CalculatePriceResponse<Prices> {
    isFull: true;
}

export type PriceSummary = CalculatePriceLiteResponse | CalculatePriceFullResponse;

interface ValidationContext {
    key: string;
    value: string;
}
interface ValidationError {
    context: ValidationContext;
}

export interface PriceSummaryValidationError {
    validationErrors: ValidationError[];
}

// Offer Service stuff
export interface OfferParams extends Offer {
    salesOrg: string;
    distrChan: string;
    division: string;
    documentType: string;
    currency: string;
    schemaId: string;
    offerType: string;
    quoteAssistInfo: string;

    // not used in quote assist
    salesOffice?: string;
}

export interface OfferPriceCalculationParams {
    language: string;
    offer: OfferParams;
}

export interface SetQuoteAsClosedParams {
    sapDocumentNumber: string;
    customerId: string;
    expirationDate: string;
    prices: Prices;
    voucherCode: string;
}

export interface OfferPriceCalculationResponse {
    offer: {
        totalAmount: number;
        grossTotal: number;
        netTotal: number;
        items: OfferItem[];
    };
    prices: Prices;
}

export interface OfferCreationResponse {
    documentNumber: string;
    expirationDate: string;
    messages: {
        type: string;
        message: string;
    }[];
}
